import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { FeedbackService } from "@app/shared/services/feedback/feedback.service";
import { SpinnerService } from "@app/shared/services/spinner/spinner.service";
import { SliderComponent } from "@app/shared/slider/slider.component";
import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { heroEye, heroEyeSlash } from "@ng-icons/heroicons/outline";

import { ILogin } from "../../models/iLogin.model";
import { AuthService } from "../../services/authentication/auth.service";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgIconComponent,
    SliderComponent,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
  viewProviders: [provideIcons({ heroEye, heroEyeSlash })],
})
export class LoginComponent implements OnInit {
  isAuthenticated = false;

  showPassword = false;

  inputType = "password";

  loginForm = this.fb.group({
    email: ["", [Validators.required, Validators.email]],
    password: ["", Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private spinner: SpinnerService,
    private feedback: FeedbackService
  ) {}

  ngOnInit(): void {
    this.auth.autoLogin();
  }

  toggleVisibility() {
    this.showPassword = !this.showPassword;
    this.inputType = this.showPassword ? "text" : "password";
  }

  async onSubmit() {
    (await this.auth.login(this.loginForm.value as ILogin))
      .subscribe({
        error: (error) => {
          this.feedback.openModal(FeedbackType.ERROR, "Ooops!", error);
        },
      })
      .add(() => {
        this.spinner.hide();
      });
  }
}
